var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 70,
    height: 60,
    baseProfile: "tiny",
    viewBox: "0 0 70 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9713",
    fillRule: "evenodd",
    d: "m69.7 56.9-16.4-28L36.9 1.1C36.5.4 35.7 0 35 0s-1.5.4-1.9 1.1L16.7 28.9.3 56.9C-.5 58.3.5 60 2.2 60h65.7c1.6 0 2.7-1.7 1.8-3.1M67.9 58H2.2s-.1 0-.2-.1v-.1L18.4 30 34.9 2.1s0-.1.2-.1c.1 0 .1.1.2.1L51.6 30 68 57.9v.1zM35 43c.6 0 1-.4 1-1V20c0-.6-.4-1-1-1s-1 .4-1 1v22c0 .6.4 1 1 1m0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
  })));
});
const SvgBigWarnIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigWarnIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjIiIGJhc2VQcm9maWxlPSJ0aW55IgogICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjcwIiBoZWlnaHQ9IjYwIgogICAgIHZpZXdCb3g9IjAgMCA3MCA2MCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgICA8Zz4KICAgICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNFQTk3MTMiIGQ9Ik02OS43LDU2LjlMNTMuMywyOC45TDM2LjksMS4xQzM2LjUsMC40LDM1LjcsMCwzNSwwYy0wLjcsMC0xLjUsMC40LTEuOSwxLjFMMTYuNywyOC45TDAuMyw1Ni45Qy0wLjUsNTguMywwLjUsNjAsMi4yLDYwaDY1LjdDNjkuNSw2MCw3MC42LDU4LjMsNjkuNyw1Ni45eiBNNjcuOSw1OEgyLjJjMCwwLTAuMSwwLTAuMi0wLjFjMCwwLDAsMCwwLTAuMUwxOC40LDMwTDM0LjksMi4xYzAsMCwwLTAuMSwwLjItMC4xYzAuMSwwLDAuMSwwLjEsMC4yLDAuMUw1MS42LDMwTDY4LDU3LjljMCwwLDAsMCwwLDAuMUM2OCw1OCw2Ny45LDU4LDY3LjksNTh6IE0zNSw0M2MwLjYsMCwxLTAuNCwxLTFWMjBjMC0wLjYtMC40LTEtMS0xcy0xLDAuNC0xLDF2MjJDMzQsNDIuNiwzNC40LDQzLDM1LDQzeiBNMzUsNDdjLTEuMSwwLTIsMC45LTIsMnMwLjksMiwyLDJzMi0wLjksMi0yUzM2LjEsNDcsMzUsNDd6Ii8+CiAgICA8L2c+Cjwvc3ZnPg==";